export enum EventName {
  DetectTooltip = "DetectTooltip",
  StartDraggingFood = "StartDraggingFood",
  StopDraggingFood = "StopDraggingFood",
  DropFood = "DropFood",
  RemoveFood = "RemoveFood",
  RequestFood = "RequestFood",
  FoundRequestedFood = "FoundRequestedFood",
  NotFoundRequestedFood = "NotFoundRequestedFood",
}
